var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{class:_vm.shouldShowTicker ? 'mb-3 mt-3' : 'my-0'},[(_vm.shouldShowTicker)?_c('v-col',{staticClass:"px-0 outlined-panel pt-1"},[_c('div',{ref:"tickerWidget",staticClass:"tradingview-widget-container"},[_c('div',{staticClass:"tradingview-widget-container__widget"})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }